// JS
require('swiper');
require('./lottie-player.js');
require('./lottie.min.js');
require('./toastify.js');
require('./init.js');
// Sass
require('./../sass/index.sass');